import { z } from "zod";

import { riskyEmailPolicySchema } from "@signalist/shared-types";

/**
 * The two per-list email-deliverability overrides (PREC-4261). `null` means "use the workspace
 * default" from Company Settings → Contacts & Enrichment, and must stay distinct from an explicit
 * `false`: both are carried as they are, never coerced. Spread into the list response and the
 * update request with `...ListEmailDeliverabilityOverridesSchema.shape`.
 */
export const ListEmailDeliverabilityOverridesSchema = z.object({
	emailVerificationEnabled: z.boolean().nullable().optional(),
	riskyEmailPolicy: riskyEmailPolicySchema.nullable().optional(),
});

export type ListEmailDeliverabilityOverrides = z.infer<
	typeof ListEmailDeliverabilityOverridesSchema
>;
